import { data } from 'qrcode.vue';
import api from '../../../api/index';
import apiShopkeeperApp from '../../../api/shopkeeperAppApi';

export default {
  register({ rootGetters }, value) {
    return api.post('/shopkeeper', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  registerDemo({ rootGetters }, value) {
    return api.post('/shopkeeper/demo', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  registerAssDemo({ rootGetters }, value) {
    return api.post('/shopkeeper/assinatura-demo', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getPaymentOptions({}, id) {
    return apiShopkeeperApp.get(`/payment/get-payment-options/${id}`);
  },
  selectedPayment({}, data) {
    return apiShopkeeperApp.post('/payment/selected-payment-options', data);
  },
  savePaymentOptions({}, data) {
    return apiShopkeeperApp.post('/payment/save-payment-options', data);
  },
  updateStatusDemo({ rootGetters }, value) {
    return api.post('/shopkeeper/update-status-demo', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  verifyIfHasApp({ rootGetters }, shopkeeperId) {
    return api.get(`/shopkeeper/verify-if-has-app/${shopkeeperId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  verifyPaymentAppPix({}, fatura) {
    return api.get(`/shopkeeper/verify-payment-app-pix/${fatura}`);
  },
  showInfoAssinatura({ rootGetters }, id) {
    return api.get('payment/split/info-assinatura/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  showFaturaId({ rootGetters }, id) {
    return api.get('payment/split/info-fatura/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  showFaturaIdExterna({ rootGetters }, id) {
    return api.get('payment/split/info-fatura-externa/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  expiredFaturaId({ rootGetters }, id) {
    return api.get('payment/split/expired-fatura/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  activate({ rootGetters }, value) {
    return api.post('/partner/activate', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  efetuarPagamento({ rootGetters }, data) {
    return api.post('shopkeeper/efetuar-pagamento-plano', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  efetuarPagamentoApp({ rootGetters }, data) {
    return api.post('shopkeeper/efetuar-pagamento-plano-app', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarCategoriasAdmin({}, id) {
    return apiShopkeeperApp.get(`buscar-categoria-admin/${id}`);
  },
  buscarCategorias({}, data) {
    return apiShopkeeperApp.get(
      `buscar-categoria/${data.id}?user_id=${data.user_id}`
    );
  },
  buscarCategoriasId({}, data) {
    return apiShopkeeperApp.get(
      `buscar-categoria-id/${data.categoriaId}/${data.lojistaId}`
    );
  },
  buscarCategoriasLojista({}, data) {
    return apiShopkeeperApp.get(
      `buscar-categoria-lojista/${data.categoriaId}/${data.lojistaId}`
    );
  },
  updateProductsCategory({}, data) {
    return apiShopkeeperApp.post(`alterar-produto-categoria`, data);
  },
  sendUpdateCategory({}, data) {
    return apiShopkeeperApp.post(`alterar-categoria-produtos-all`, data);
  },
  updateProductIdCategory({}, data) {
    return apiShopkeeperApp.post(`update-productId-category`, data);
  },
  getProductCategoryShopkeeper({}, data) {
    return apiShopkeeperApp.get(
      `get-product-category/${data.categoryId}/${data.lojistaId}`
    );
  },
  salvarCategoriaLojista({}, data) {
    return apiShopkeeperApp.post(`salvar-categoria-lojista`, data);
  },
  novaCategoriaLojista({}, data) {
    return apiShopkeeperApp.post(`nova-categoria-lojista`, data);
  },
  buscarCodBar({}, codbar) {
    return apiShopkeeperApp.get('buscar-cod-bar?codbar=' + codbar);
  },
  salvarNovoProduto({}, data) {
    return apiShopkeeperApp.post('salvar-novo-produto', data);
  },
  buscarValorAss({ rootGetters }, id) {
    return api.get(`shopkeeper/buscar-valor-assinatura/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  validarCupomDesconto({ rootGetters }, data) {
    return api.post(`shopkeeper/buscar-cupom-desconto`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarPlano({ rootGetters }, id) {
    return api.get(`shopkeeper/buscar-assinatura/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  solicitarPlano({ rootGetters }, data) {
    return api.post('shopkeeper/assinar-plano', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  todosPlanos({ rootGetters }) {
    return api.get('admin/todos-planos-ativos', {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getTokenLojistaApi({ rootGetters }, id) {
    return api.get('shopkeeper/token-lojista-token/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getTokenLojistaFacebookAds({ rootGetters }, id) {
    return api.get('dados-token-facebook-ads/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getWhatsAppClick({}, data) {
    return apiShopkeeperApp.get(
      `whatsapp/get-click-whatsapp/${data.userId}?dateStart=${data.dateStart}&dateEnd=${data.dateEnd}`
    );
  },
  getFacebookAds({}, url) {
    return api.get(url);
  },
  getGoogleAnalytics({ rootGetters }, data) {
    return api.get(
      `google-analytics/${data.usuario_id}?start=${data.start}&end=${data.end}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getValidTokenLojistaApi({ rootGetters }, id) {
    return api.get('shopkeeper/verify-active-api/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  integrarLojistaApi({ rootGetters }, id) {
    return api.get('shopkeeper/active-api/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  planoId({ rootGetters }, id) {
    return api.get(`admin/plano-ativo-id/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  assinaturaCupons({ rootGetters }) {
    return api.get(`admin/assinatura-cupons`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  assinaturaCuponsSend({ rootGetters }, data) {
    return api.post(`admin/assinatura-cupons-send`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  assinaturaCuponsInativar({ rootGetters }, id) {
    return api.get(`admin/assinatura-cupons-inativar/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  assinaturaCuponsExcluir({ rootGetters }, id) {
    return api.get(`admin/assinatura-cupons-excluir/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getLojistasImagens({ rootGetters }, id) {
    return api.get('shopkeeper/lojista-imagens-faltantes', {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  uploadImagem({ rootGetters }, data) {
    return api.post('shopkeeper/lojista-imagem-upload', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  uploadImagemSave({ rootGetters }, data) {
    return api.post('shopkeeper/save-lojista-imagem-upload', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  minhaImagensPlano({ rootGetters }, id) {
    return api.get(`shopkeeper/minhas-imagens-plano/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateSegments(_, value) {
    return api.post('lojista/segmentos', value);
  },
  lojistaPorCnpj(_, cnpj) {
    return api.get(`/shopkeeper/lojista-por-cnpj/${cnpj}`);
  },
  getClerk({ rootGetters }, construpUserId) {
    return api.get(`/clerk/${construpUserId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveClerk({ rootGetters }, fields) {
    return api.post(`/clerk/create`, fields, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateClerk({ rootGetters }, fields) {
    return api.put(`/clerk/update/${fields.id}`, fields, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  createPasswordClerk({}, fields) {
    return api.post('/password-clerk', fields);
  },
  validateTokenClerk({}, fields) {
    return api.post(`/validate-token-clerk`, fields);
  },
  deleteClerk({ rootGetters }, id) {
    return api.delete(`/clerk/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  // PERMISSÕES BALCONISTA
  savePermission({ rootGetters }, fields) {
    return api.post(`/clerk/permission-clerk`, fields, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAddressAdditional({ rootGetters }, userId) {
    return api.get(`/shopkeeper/address/getAll/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateAddressAdditional({ rootGetters }, data) {
    return api.post('/shopkeeper/address/update', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteAddressAdditional({ rootGetters }, data) {
    return api.post('/shopkeeper/address/delete', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  createAddressAdditional({ rootGetters }, data) {
    return api.post('/shopkeeper/address/additional', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  // Editar pelo balconista
  updateAddressAdditionalByClerk({ rootGetters }, data) {
    return api.post('/clerk/shopkeeper/address/update', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteAddressAdditionalByClerk({ rootGetters }, data) {
    return api.post('/clerk/shopkeeper/address/delete', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  createAddressAdditionalByClerk({ rootGetters }, data) {
    return api.post('/clerk/shopkeeper/address/additional', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAddressAdditionalShopkeeper({ rootGetters }, userId) {
    return api.get(`/clerk/shopkeeper/address/getAll/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  getSocialMedias({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/customization/social-medias/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveNewMenu({ rootGetters }, value) {
    return apiShopkeeperApp.post('/menu/new', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  editMenu({ rootGetters }, value) {
    return apiShopkeeperApp.post(`/menu/edit/${value.id}`, value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  showMenu({ rootGetters }, value) {
    return apiShopkeeperApp.post(`menu/show-all/${value}`, value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  inativeCategory({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/menu/inactivate/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  inactivateMenuApp({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/menu/inactivate/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getMenusApp({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/menu/show-all/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getMenuHomeBanner({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/menu/show-all-category/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  sendBannerMenu({ rootGetters }, data) {
    return apiShopkeeperApp.post('/menu/send-menu-banner', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getProductCategory({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/menu/product-category/${data.id}/${data.lojistaId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  newMenuProductsCategory({ rootGetters }, data) {
    return apiShopkeeperApp.post('/menu-product/new', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleMenuCategoryProduct({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/menu-product/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getMenuProductsApp({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/menu-product/show-all/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveSocialMedias({ rootGetters }, value) {
    return apiShopkeeperApp.post('/customization/social-medias', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveLinkTree({ rootGetters }, data) {
    return apiShopkeeperApp.post('/customization/linktree', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getLinkTree({ rootGetters }, shopkeeperId) {
    return apiShopkeeperApp.get(`/customization/linktree/${shopkeeperId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateOrderLinkTree({ rootGetters }, data) {
    return apiShopkeeperApp.put('/customization/updateOrderLinktree', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getLinktreeClicks({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `customization/report-link/${data.userId}?dateStart=${data.dateStart}&dateEnd=${data.dateEnd}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getProducts({ rootGetters }, { familyId, currentPage = 1, productName }) {
    return apiShopkeeperApp.get(
      `/product/get-all/${familyId}?page=${currentPage}&productName=${
        productName || ''
      }`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  saveSelectedProducts({ rootGetters }, value) {
    return apiShopkeeperApp.post('/products/select', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getSelectedProducts(
    { rootGetters },
    {
      userId,
      productName,
      codInt,
      familyId,
      currentPage = 1,
      typeProducts = 'geral',
      startDate,
      endDate,
      status = '',
      isPartner = false,
      isTiny = false,
      tinyStatus = '',
      marketplaceId = '',
      integrated = false,
    }
  ) {
    return apiShopkeeperApp.get(
      `/products/selected/${userId}?page=${currentPage}
      &productName=${productName || ''}
      &codInt=${codInt || ''}
      &familyId=${familyId || 0}
      &typeProducts=${typeProducts || 'geral'}
      &startDate=${startDate || ''}
      &endDate=${endDate || ''}
      &status=${status || ''}
      &isPartner=${isPartner}
      &isTiny=${isTiny}
      &marketplaceId=${marketplaceId}
      &integrated=${integrated}
      &tinyStatus=${tinyStatus}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  inativeSelectedProduct({ rootGetters }, { userId, productId }) {
    return apiShopkeeperApp.get(`/products/desativar/${userId}/${productId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  ativarProdutoLojista({ rootGetters }, { userId, productId }) {
    return apiShopkeeperApp.get(`/products/reativar/${userId}/${productId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  savePriceDiscountRule({}, data) {
    return apiShopkeeperApp.post(`/products/save-discount-rules`, data);
  },
  deleteProductMarketplace({}, data) {
    return apiShopkeeperApp.post(
      `/integration/marketplace/delete-product`,
      data
    );
  },
  getMenuPromotion({}, id) {
    return apiShopkeeperApp.get(`/products/get-menu-promotion/${id}`);
  },
  saveMenuPromotion({}, data) {
    return apiShopkeeperApp.post(`/products/save-menu-promotion`, data);
  },
  saveProductMenuPromotion({}, data) {
    return apiShopkeeperApp.post(`/products/save-product-menu-promotion`, data);
  },
  validarCodInternoLojista({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/products/validar-cod-interno/${data.lojista_id}/${data.cod}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  async clientesCadastro({ rootGetters, commit }, userId) {
    const response = await apiShopkeeperApp.get(
      `/types-usuarios-cadastro/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
    commit('setUserTypesEnabled', response.data);
    return response;
  },

  async cathProfission({ rootGetters, commit }, userId) {
    const response = await apiShopkeeperApp.get(`area-professional/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
    commit('setUserTypesEnabled', response.data);
    return response;
  },

  async editProfession({ rootGetters }, data) {
    const response = await apiShopkeeperApp.post(
      `area-professional/edit-profession`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },

  async deleteProfession({ rootGetters }, data) {
    const response = await apiShopkeeperApp.post(
      `area-professional/delete-profession`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },

  async getCustom({ rootGetters, commit }, userId) {
    const response = await apiShopkeeperApp.get(
      `area-professional/get-custom/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
    commit('setUserTypesEnabled', response.data);
    return response;
  },

  async createProfission({ rootGetters, commit }, data) {
    const response = await apiShopkeeperApp.post(
      `area-professional/create-profission`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
    commit('setUserTypesEnabled', response.data);
    return response;
  },
  async isActiveProfission({ rootGetters, commit }, data) {
    const response = await apiShopkeeperApp.post(
      `area-professional/is-active-profission`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
    commit('setUserTypesEnabled', response.data);
    return response;
  },

  requirePhoneInRegister({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      `/customization/require-phone-register`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getRequireFields({ rootGetters }, construp_user_id) {
    return apiShopkeeperApp.get(
      `/customization/get-fields-require/${construp_user_id}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  minhasMarcas({}, data) {
    return apiShopkeeperApp.get(`/minhas-marcas/${data.id}/${data.campanhaId}`);
  },
  atualizarMarcasRegra({}, data) {
    return apiShopkeeperApp.post('/atualziar-marcas-regra', data);
  },
  alterarStatusPromocao({}, construp_user_id) {
    return apiShopkeeperApp.get(`/alterar-status-promocao/${construp_user_id}`);
  },
  minhasRegras({}, construp_user_id) {
    return apiShopkeeperApp.get(`/minhas-regras/${construp_user_id}`);
  },
  addPontos({}, data) {
    return apiShopkeeperApp.post('/adicionar-pontos-campanha', data);
  },
  alterarStatusRegra({}, id) {
    return apiShopkeeperApp.get(`/alterar-status-regra/${id}`);
  },
  getColaborador({}, id) {
    return api.get(`/clerk/search/${id}`);
  },
  getCupomPoints({}, id) {
    return apiShopkeeperApp.get(`/get-cupom-points/${id}`);
  },
  buscarCuponsSorteio({}, data) {
    return apiShopkeeperApp.post(`/buscar-cupons-sorteio`, data);
  },
  getQrCodePoints({}, id) {
    return apiShopkeeperApp.get(`/get-qr-code-points/${id}`);
  },
  newRaffleCampaignCouponQtd({}, data) {
    return apiShopkeeperApp.post(`/new-raffle-qtd`, data);
  },
  getRaffleCampaign({}, id) {
    return apiShopkeeperApp.get(`/get-raffle-campaign/${id}`);
  },
  getRaffleCampaignAdmin({}, id = '') {
    return apiShopkeeperApp.get(`/get-raffle-campaign-admin?id=${id}`);
  },
  updateStatusRaffle({}, id) {
    return apiShopkeeperApp.get(`/update-status-raffle/${id}`);
  },
  nomeGanhador({}, data) {
    return apiShopkeeperApp.get(
      `/buscar-nome-ganhador/${data.ganhador}/${data.sorteioId}`
    );
  },
  getCouponsId({}, id) {
    return apiShopkeeperApp.get(`/get-coupons-campaign/${id}`);
  },
  saveRaffleCampaign({}, data) {
    return apiShopkeeperApp.post('/save-raffle-campaign', data);
  },
  pontosUsuarioCampanha({}, data) {
    return apiShopkeeperApp.get(
      `/pontos-usuario/${data.campanhaId}?areaId=${data.areaId}`
    );
  },
  alterarStatusCampanha({}, id) {
    return apiShopkeeperApp.get(`/alterar-status-campanha/${id}`);
  },
  excluirRegra({}, id) {
    return apiShopkeeperApp.get(`/excluir-regra/${id}`);
  },
  sendFormRegras({}, data) {
    return apiShopkeeperApp.post('/send-form-regra', data);
  },
  sendFormCampanhas({}, data) {
    return apiShopkeeperApp.post('/send-form-campanha', data);
  },
  meusPremios({}, construp_user_id) {
    return apiShopkeeperApp.get(`/meus-premios/${construp_user_id}`);
  },
  alterarStatusPremio({}, id) {
    return apiShopkeeperApp.get(`/alterar-status-premio/${id}`);
  },
  excluirPremio({}, id) {
    return apiShopkeeperApp.get(`/excluir-premio/${id}`);
  },
  sendFormPremio({}, data) {
    return apiShopkeeperApp.post('/send-form-premio', data);
  },
  premioSolicitadoAtualizar({}, data) {
    return apiShopkeeperApp.post('/premio-solicitado-atualizar', data);
  },
  premioSolicitado({}, id) {
    return apiShopkeeperApp.get(`/premio-solicitado-lojista/${id}`);
  },
  getGoogleShopping({}, construp_user_id) {
    return apiShopkeeperApp.get(
      `/google-api/dados-lojista/${construp_user_id}`
    );
  },
  getTiny({}, id) {
    return apiShopkeeperApp.get(`/tiny/dados-lojista/${id}`);
  },
  saveTiny({}, data) {
    return apiShopkeeperApp.post(`/tiny/save`, data);
  },
  saveProductTiny({}, data) {
    return apiShopkeeperApp.post(`/tiny/save-product`, data);
  },
  saveProductAllTiny({}, data) {
    return apiShopkeeperApp.post(`/tiny/save-product-all`, data);
  },
  saveGoogleShopping({}, data) {
    return apiShopkeeperApp.post('/google-api/save-product', data);
  },
  actionGoogleShopping({}, data) {
    return apiShopkeeperApp.post('/google-api/action-product', data);
  },
  updClientesCadastro({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/types-usuarios-cadastro-upd`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateSelectedProduct({ rootGetters }, { userId, product }) {
    return apiShopkeeperApp.put(
      `/products/selected/${userId}/${product.productId}`,
      { ...product },
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  trashSelectedProductId({}, data) {
    return apiShopkeeperApp.post('/products/trash-product-id', data);
  },
  dadosProdutoId({}, data) {
    return apiShopkeeperApp.get(
      `/products/data-product-id/${data.id}/${data.lojistaId}`
    );
  },
  alterarProdutoId({}, data) {
    return apiShopkeeperApp.post(`/products/update-product-id`, data);
  },
  alterarHomeProduct({}, data) {
    return apiShopkeeperApp.post(`/products/update-product-home`, data);
  },
  saveAboutCompany({ rootGetters }, data) {
    return apiShopkeeperApp.post('/customization/about-company', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  // savePercentAddition({ rootGetters }, data) {
  //   return apiShopkeeperApp.post('/customization/addition-percent', data, {
  //     headers: {
  //       Authorization: `Bearer ${rootGetters.getToken}`,
  //     },
  //   });
  // },
  // getPercent({ rootGetters }, construp_user_id) {
  //   return apiShopkeeperApp.get(`/customization/get-percent/${construp_user_id}`, {
  //     headers: {
  //       Authorization: `Bearer ${rootGetters.getToken}`,
  //     },
  //   });
  // },
  saveActivePrice({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      '/customization/atualizar-mostrar-preco',
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getActivePrice({ rootGetters }, id) {
    return apiShopkeeperApp.get('/customization/mostrar-preco/' + id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  nomeLojista({}, id) {
    return api.get('/dados/shopkeeper/' + id);
  },
  getAboutCompany({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/customization/about-company/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  getAllFormData({ rootGetters }, shopkeeperId) {
    return apiShopkeeperApp.get(`/notifications/news/get/${shopkeeperId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  getGuaranteeError({}, shopkeeperId) {
    return apiShopkeeperApp.get(`/guarantee-error/${shopkeeperId}`);
  },

  getProductsBel({}, shopkeeperId) {
    return apiShopkeeperApp.get(`/products-bel/${shopkeeperId}`);
  },

  dellProductsBel({}, shopkeeperId) {
    return apiShopkeeperApp.delete(`/products-bel-dell/${shopkeeperId}`);
  },

  dellProductFileBel({}, shopkeeperId) {
    return apiShopkeeperApp.delete(`/product-file-bel-dell/${shopkeeperId}`);
  },

  newFileProductBell({}, data) {
    return apiShopkeeperApp.post(`/products-bel-new`, data);
  },

  newGuaranteeError({}, data) {
    return apiShopkeeperApp.post(`/guarantee-error-new`, data);
  },

  upGuaranteeError({}, data) {
    return apiShopkeeperApp.put(`/guarantee-error-update`, data);
  },

  dellGuaranteeError({}, id) {
    return apiShopkeeperApp.delete(`/guarantee-error-dell/${id}`);
  },

  getAgentIaPrompt({}, shopkeeperId) {
    return apiShopkeeperApp.get(`/agent-ia-prompt/${shopkeeperId}`);
  },

  savePrompt({}, data) {
    return apiShopkeeperApp.put(`/agent-ia-save-prompt`, data);
  },

  saveContextAgentIa({}, data) {
    return apiShopkeeperApp.put(`/agent-ia-save-context`, data);
  },

  saveContextAgentIaBelEnergy({}, data) {
    return apiShopkeeperApp.put(`/agent-ia-save-context-belenergy`, data);
  },

  deleteSubsciberNewsletter({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/notifications/news/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  editSubsciberNewsletter({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/notifications/news/update`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  getDetalhesProdutoGeral({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/detalhes-produtos-gerais/${data.productId}/${data.lojistaId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  searchUrl({ rootGetters }, id) {
    return apiShopkeeperApp.get(`search-url/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getPaymentTags({ rootGetters }, id) {
    return apiShopkeeperApp.get(`payment/tags/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  syncStockApi({}, id) {
    return apiShopkeeperApp.get(`valid-sync-stock/${id}`);
  },
  initSyncApi({}, id) {
    return apiShopkeeperApp.get(`init-sync-stock/${id}`);
  },
  initSyncPriceApi({}) {
    return apiShopkeeperApp.get(`hidromar-atualizar-preco-all`);
  },
  carflaxInitSyncPriceApi({}) {
    return apiShopkeeperApp.get(`carflax-atualizar-preco-all`);
  },
  carflaxInitSyncApi({}, id) {
    return apiShopkeeperApp.get(`carflax-init-sync-stock/${id}`);
  },
  buscarOrcamentoAll({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      `lojista/buscar-orcamento/${data.lojista_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },

  getAllPartners({ rootGetters }, data) {
    return api.get(
      `partner/get-partners/${data.idShopkeeper}?search=${data.search}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },

  softDeletePartner({ rootGetters }, data) {
    return api.delete(
      `partner/delete-partner/${data.partnerId}/${data.shopkeeperId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },

  createNewPartner({ rootGetters }, data) {
    return api.post(`partner/new-partner`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  savePaymentTags({ rootGetters }, data) {
    return apiShopkeeperApp.post('payment/save-tags', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getDetalhesProdutoFixadores({ rootGetters }, productId) {
    return apiShopkeeperApp.get(`/detalhes-produtos-fixadores/${productId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getOpeningHours({ rootGetters }, shopkeeperId) {
    return apiShopkeeperApp.get(
      `/customization/get-hour-saved/${shopkeeperId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  saveOpeningHours({ rootGetters }, data) {
    return apiShopkeeperApp.post('/customization/save-hour', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  updateOpeningHours({ rootGetters }, data) {
    return apiShopkeeperApp.post('/customization/update-hour', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveCustomization({ rootGetters }, data) {
    return apiShopkeeperApp.post('/customization', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getCustomization({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/customization/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getModCosntruct({ rootGetters }, data) {
    return apiShopkeeperApp.get(`/customization/get-construct/${data.userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveModConstruct({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      `/customization/in-construct/${data.userId}/${data.isConstruct}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  saveBanner({ rootGetters }, data) {
    return apiShopkeeperApp.post('/customization/banner', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getBanner({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/customization/banner/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  listBanner({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/customization/banners/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteBanner({ rootGetters }, userId) {
    return apiShopkeeperApp.delete(`/customization/banner/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveTermsAndService({ rootGetters }, data) {
    return apiShopkeeperApp.post('/customization/terms-privacy', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveReturnPolicy({ rootGetters }, data) {
    return apiShopkeeperApp.post('/customization/return-policy', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAllClients({ rootGetters }, filters) {
    return apiShopkeeperApp.post(`/client/get-all`, filters, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  blockedClients({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/blocked-client`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getDepartmentsCombo({ rootGetters }) {
    return apiShopkeeperApp.get(`/department/get-combo`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveFreight({ rootGetters }, data) {
    return apiShopkeeperApp.post('/freights', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getFreight({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/freights/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveMotorcycleForm({ rootGetters }, data) {
    return apiShopkeeperApp.post('/freights/save-motorcicle', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateMotorcycle({}, data) {
    return apiShopkeeperApp.post('/freights/update-motorcycle', data);
  },
  saveZipBrandForm({ rootGetters }, data) {
    return apiShopkeeperApp.post('/freights/save-zip-brand', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  setStatusMotorcicle({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/freights/set-status-motorcicle/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  zipBrandDell({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/freights/dell-zip-brand/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getDepartments({ rootGetters }) {
    return apiShopkeeperApp.get(`/product/category`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getCategories({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/product/sub-menu`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getProductsByCategory({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/product/push-product-itens`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getProductsTable({ rootGetters }, familyId) {
    return apiShopkeeperApp.get(`/product/get-products-table/${familyId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getChildDepartments({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/department/get-child-departments/${data.departmentId}?tipo=${data.tipo}&lojistaId=${data.lojistaId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getFamiliesByDepartmentId({ rootGetters }, departmentId) {
    return apiShopkeeperApp.get(`/department/get-families/${departmentId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getProductsByFamilyId(
    { rootGetters },
    { familyId, currentPage = 1, productName, tipo, userId, brand, status }
  ) {
    return apiShopkeeperApp.get(
      `/product/get-by-family/${familyId}?page=${currentPage}&productName=${
        productName || ''
      }&construpUserId=${userId || 0}&tipo=${tipo || ''}&brand=${
        brand || ''
      }&status=${status || ''}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  savePaymentMethod({ rootGetters }, data) {
    return apiShopkeeperApp.post('/payment-methods', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveMinPurchase({ rootGetters }, data) {
    return apiShopkeeperApp.post('/payment-methods/min-purchase', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  configGpt({ rootGetters }, data) {
    return apiShopkeeperApp.post('/config-gpt', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getConfig({ rootGetters }, data) {
    return apiShopkeeperApp.get('/get-data', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getPaymentMethods({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/payment-methods/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getRemoveDiscountPaymentMethod({}, data) {
    return apiShopkeeperApp.post(
      `/products/remove-discount-payment-method?page=${data.currentPage}`,
      data
    );
  },
  saveRemoveDiscountPaymentMethod({}, data) {
    return apiShopkeeperApp.post(
      `/products/save-remove-discount-payment-method`,
      data
    );
  },
  savePaymentAccount({ rootGetters }, data) {
    return apiShopkeeperApp.post('/payment-account', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getPaymentAccount({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`/payment-account/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAppOrders(
    { rootGetters },
    {
      userId,
      clerkId,
      clientName,
      vendedor,
      orderNumber,
      startDate,
      endDate,
      status,
      paymentType,
      itensPerPage,
      currentPage = 1,
      abandonedCart,
      isRelatory,
    }
  ) {
    let queryParams = `${userId}`;
    queryParams += `?clerkId=${clerkId || ''}`;
    queryParams += `&page=${currentPage || 1}`;
    queryParams += `&clientName=${clientName || ''}`;
    queryParams += `&vendedor=${vendedor || ''}`;
    queryParams += `&orderNumber=${orderNumber || ''}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    queryParams += `&status=${status || ''}`;
    queryParams += `&paymentType=${paymentType || ''}`;
    queryParams += `&perPage=${itensPerPage || ''}`;
    queryParams += `&abandonedCart=${abandonedCart || 'false'}`;
    queryParams += `&isRelatory=${isRelatory || 'false'}`;

    return apiShopkeeperApp.get(`/app/orders/${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAppProductsOrders(
    { rootGetters },
    {
      userId,
      clerkId,
      clientName,
      vendedor,
      orderNumber,
      startDate,
      endDate,
      status,
      paymentType,
    }
  ) {
    let queryParams = `${userId}`;
    queryParams += `?clerkId=${clerkId || ''}`;
    queryParams += `&clientName=${clientName || ''}`;
    queryParams += `&vendedor=${vendedor || ''}`;
    queryParams += `&orderNumber=${orderNumber || ''}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    queryParams += `&status=${status || ''}`;
    queryParams += `&paymentType=${paymentType || ''}`;

    return apiShopkeeperApp.get(`/app/orders/products/${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateOrderStatus({ rootGetters }, { userId, id, newStatus, received }) {
    return apiShopkeeperApp.put(
      '/app/orders/update-status',
      { userId, id, newStatus, received },
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  updateOrderStatusLoja({ rootGetters }, data) {
    return apiShopkeeperApp.put('/app/orders/update-status-loja', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  sendReturnPayment({ rootGetters }, data) {
    return apiShopkeeperApp.post('/app/orders/return-payment', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  enviarPedidoCitel({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/hidromar-enviar-pedido/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  enviarPedidoCitelEstrela({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/estrela-vale-enviar-pedido/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  enviarPedidoCitelCarflax({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/carflax-enviar-pedido/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  enviarPedidoCitelAtena({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/atena-enviar-pedido/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  sendWebhookPaymentBocao({}, id) {
    return apiShopkeeperApp.get(`/bocao-send-order/${id}`);
  },
  getNfeCarflaxPaymentId({}, id) {
    return apiShopkeeperApp.get(`/carflax-nfe-pedido/${id}`);
  },
  buscarLinkApp({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/buscar-link-app/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getInvoicingSummary(
    { rootGetters },
    { userId, clerkId, startDate, endDate }
  ) {
    let queryParams = `?clerkId=${clerkId || ''}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;

    return apiShopkeeperApp.get(
      `/app/orders/${userId}/invoice-summary${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getStatistics({ rootGetters }, { userId, clerkId, startDate, endDate }) {
    let queryParams = `?clerkId=${clerkId || ''}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;

    return apiShopkeeperApp.get(
      `/app/orders/${userId}/statistics${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getGeneralGraph(
    { rootGetters },
    { userId, startDate, endDate, generalGraphStatus }
  ) {
    let queryParams = `?startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    queryParams += `&status=${generalGraphStatus || ''}`;

    return apiShopkeeperApp.get(
      `/app/orders/${userId}/statistics/general-graph${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  saveNotification({ rootGetters }, data) {
    return apiShopkeeperApp.post('/notifications', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getHighlights({}, id) {
    return apiShopkeeperApp.get(`/customization/highlights/${id}`);
  },
  dellHighlights({}, id) {
    return apiShopkeeperApp.get(`/customization/highlights-delete/${id}`);
  },
  saveHighlights({}, data) {
    return apiShopkeeperApp.post('/customization/highlights', data);
  },
  getNotification({ rootGetters }, { userId, notificationId }) {
    return apiShopkeeperApp.get(
      `/notifications/${userId}?notificationId=${notificationId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  listNotification(
    { rootGetters },
    { userId, itemsPerPage, currentPage = 1, startDate, endDate }
  ) {
    let queryParams = `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;

    return apiShopkeeperApp.get(
      `/notifications/all/${userId}?itemsPerPage=${itemsPerPage}&page=${currentPage}${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  deleteNotification({ rootGetters }, { userId, notificationId }) {
    return apiShopkeeperApp.delete(
      `/notifications/${userId}?notificationId=${notificationId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getNotificationAppCms({}, id) {
    return apiShopkeeperApp.get(`/notifications/app/cms/getAll/${id}`);
  },
  sendNotificationAppCms({}, data) {
    return apiShopkeeperApp.post('/notifications/app/cms/create', data);
  },
  deleteNotificationAppCms({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/notifications/app/cms/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getOrderDetails({ rootGetters }, { userId, orderId, shopkeepersIds }) {
    return apiShopkeeperApp.get(
      `/app/orders/details?orderId=${orderId}&userId=${userId}&shopkeepersIds=${shopkeepersIds}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  saveInvoiceOrder({}, data) {
    return apiShopkeeperApp.post('/app/orders/save-invoice', data);
  },
  deleteInvoiceOrder({}, data) {
    return apiShopkeeperApp.delete(
      `/app/orders/delete-invoice/${data.orderId}/${data.construpUserId}`
    );
  },

  cathUserCoupon({ rootGetters }, { couponId, startDate, endDate }) {
    let queryParams = `${couponId}`;
    queryParams += `?startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    return apiShopkeeperApp.get(`/cath-user-coupon/${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  savePaymentCredit({ rootGetters }, data) {
    return apiShopkeeperApp.post('/credit-payment', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  getPaymentCredit({ rootGetters }, idUser) {
    return apiShopkeeperApp.get(`/credit-payment/all/${idUser}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  deletePaymentCredit({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/credit-payment/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  listProfessionalRequestApprovals(
    { rootGetters },
    {
      userId,
      requestNumber,
      status,
      itemsPerPage,
      currentPage = 1,
      startDate,
      endDate,
    }
  ) {
    let queryParams = `page=${currentPage || 1}`;
    queryParams += `&itemsPerPage=${itemsPerPage || ''}`;
    queryParams += `&userId=${userId || ''}`;
    queryParams += `&status=${status || ''}`;
    queryParams += `&requestNumber=${requestNumber || ''}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;

    return apiShopkeeperApp.get(
      `/professional/request-approval/list?${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  acceptProfessional({ rootGetters }, { userId, professionalId }) {
    return apiShopkeeperApp.post(
      '/professional/request-approval/accept',
      {
        userId,
        professionalId,
      },
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  declineProfessional({ rootGetters }, { userId, professionalId }) {
    return apiShopkeeperApp.post(
      '/professional/request-approval/decline',
      {
        userId,
        professionalId,
      },
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getProfessional(_, { userId, professionalId }) {
    return apiShopkeeperApp.get(
      `professional?construpUserId=${userId}&professionalId=${professionalId}`
    );
  },

  getClientApp({ rootGetters }, user_id) {
    return apiShopkeeperApp.get(`/client/client/get-all-data/${user_id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  getPixelId({ rootGetters }, id) {
    return apiShopkeeperApp.get(`/pixel-facebook/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  atualizarPixelId({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/pixel-facebook-atualizar`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  createWallet({ rootGetters }, data) {
    return apiShopkeeperApp.post('/payment-wallet', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  paymentWallet({ rootGetters }, data) {
    return apiShopkeeperApp.post('/payment-wallet/payment', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  updateWallet({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/payment-wallet/update/${data.id}`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  deleteWallet({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/payment-wallet/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  allWallet({ rootGetters }, { construpUserId, currentPage = 1, name = '' }) {
    return apiShopkeeperApp.get(
      `/payment-wallet/all/${construpUserId}?page=${currentPage}&name=${name}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },

  historyClientWallet({ rootGetters }, idUser) {
    return apiShopkeeperApp.get(`/payment-wallet/history/${idUser}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  historyPaymentWalletShopkeeper({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/payment-wallet/user/history/${data.construpUserId}/${data.idUser}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  allClientShopkeeper(
    { rootGetters },
    {
      construpUserId,
      currentPage = 1,
      type = '',
      value = '',
      typeSearch = 'name',
    }
  ) {
    return apiShopkeeperApp.get(
      `/payment-wallet/all-client/${construpUserId}?page=${currentPage}&type=${type}&value=${value}&type-search=${typeSearch}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getTaxaWallet({ rootGetters }, construpUserId) {
    return apiShopkeeperApp.get(`payment-wallet/getTaxa/${construpUserId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  validationApp({ rootGetters }, userId) {
    return apiShopkeeperApp.get(`app-validate/${userId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  paymentTaxaWallet({ rootGetters }, data) {
    return apiShopkeeperApp.post('payment-wallet/paymentTaxa', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getGeneralClients({ rootGetters }, filters) {
    return apiShopkeeperApp.post(
      `/client/get-general?page=${filters.currentPage}`,
      filters,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  saveSelectedProductPrice({ rootGetters }, fields) {
    return apiShopkeeperApp.post(`/products/prices`, fields, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getSelectedProductPrices(
    { rootGetters },
    { construpUserId, status, selectedProductId, currentPage = 1, perPage = 30 }
  ) {
    let queryParams = `?page=${currentPage || 1}`;
    queryParams += `&construpUserId=${construpUserId || ''}`;
    queryParams += `&selectedProductId=${selectedProductId || ''}`;
    queryParams += `&status=${status || ''}`;
    queryParams += `&perPage=${perPage || ''}`;

    return apiShopkeeperApp.get(`/products/prices${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteSelectedProductPrice(
    { rootGetters },
    { id, construpUserId, selectedProductId, state }
  ) {
    let queryParams = `?id=${id || ''}`;
    queryParams += `&construpUserId=${construpUserId || ''}`;
    queryParams += `&selectedProductId=${selectedProductId || ''}`;
    queryParams += `&state=${state || ''}`;

    return apiShopkeeperApp.delete(`/products/prices${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveSpreadsheetProductsToImport({ rootGetters }, fields) {
    return apiShopkeeperApp.post(`/products/spreadsheet-to-import`, fields, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAllBrand({ rootGetters }) {
    return apiShopkeeperApp.get(`/brand/all`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getStatusWhatsApp({}, id) {
    return apiShopkeeperApp.get(`/whatsapp/get-status-whatsapp/${id}`);
  },
  initConnectionWhatsApp({}, id) {
    return apiShopkeeperApp.get(`/whatsapp/init-connection-whatsapp/${id}`);
  },
  deleteConnectionWhatsapp({}, id) {
    return apiShopkeeperApp.get(`/whatsapp/delete-connection-whatsapp/${id}`);
  },
  newMessageWhatsApp({}, data) {
    return apiShopkeeperApp.post(`/whatsapp/new-message-whatsapp`, data);
  },
  getProductUnavailable(
    { rootGetters },
    { userId, startDate, endDate, currentPage = 1 }
  ) {
    let queryParams = `?page=${currentPage || 1}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    return apiShopkeeperApp.get(
      `/detalhes-indisponivel/${userId}${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getProductSearchInput({}, { userId, startDate, endDate, currentPage = 1 }) {
    let queryParams = `?page=${currentPage || 1}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    return apiShopkeeperApp.get(
      `/product/product-search/${userId}${queryParams}`
    );
  },
  getProductBestSellers({}, data) {
    return apiShopkeeperApp.post(`/payment/best-sellers`, data);
  },
  saveImpusionarProduto({}, data) {
    return apiShopkeeperApp.post(`/produtos/impusionar`, data);
  },
  listImpusionarProdutos({}, data) {
    return apiShopkeeperApp.post(`/produtos/list-impusionar-produtos`, data);
  },
  newImpusionaId({}, data) {
    return apiShopkeeperApp.post(`/produtos/add-impusionar-produto`, data);
  },
  deleteImpusionaId({}, data) {
    return apiShopkeeperApp.post(`/produtos/dell-impusionar-produto`, data);
  },
  updateImpusionarProduto({}, data) {
    return apiShopkeeperApp.put(`/produtos/impusionar`, data);
  },
  getImpusionarProduto({}, id) {
    return apiShopkeeperApp.get(`/produtos/impusionar/${id}`);
  },
  getWebhookEnabled(
    { rootGetters },
    { construpUserId, name = '', active = true, currentPage = 1 }
  ) {
    let queryParams = `?page=${currentPage || 1}`;
    queryParams += `&construpUserId=${construpUserId || ''}`;
    queryParams += `&active=${active}`;
    queryParams += `&name=${name || ''}`;
    return apiShopkeeperApp.get(`/webhook/enabled/list${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveWebhookEnabled({ rootGetters }, fields) {
    return apiShopkeeperApp.post(
      `/webhook/enabled`,
      {
        fields,
      },
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  toggleActiveWebhookEnabled({ rootGetters }, fields) {
    return apiShopkeeperApp.put(
      `/webhook/enabled/toggle-active`,
      {
        ...fields,
      },
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  createCoupon({ rootGetters }, data) {
    return apiShopkeeperApp.post('/discount-coupon/create', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateCoupon({ rootGetters }, data) {
    return apiShopkeeperApp.put('/discount-coupon/edit', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getCoupon({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/discount-coupon/showAllShopkeeper/${data.userId}/${data.type}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  deleteCoupon({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/discount-coupon/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  isValidCoupon({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/discount-coupon/validate-coupon`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  // ROTAS DOS SERVIÇOS
  getServiceShopkeeper({ rootGetters }, idUser) {
    return apiShopkeeperApp.get(`/services/ready-service/${idUser}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  createNewServiceShopkeeper({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/services/create-service`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateServiceShopkeeper({ rootGetters }, data) {
    return apiShopkeeperApp.post(`/services/update-service/${data.id}`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteServiceShopkeeper({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/services/delete-service/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getServiceProduct({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/services/get-service/${data.idService}/${data.idShopkeeper}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  addProductService({ rootGetters }, data) {
    return apiShopkeeperApp.post('/services/product-service', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteProductService({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/services/delete-linked-service/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getRelatedProducts({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/products/related/${data.shopkeeperId}/${data.id}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  deleteProductRelated({ rootGetters }, data) {
    return apiShopkeeperApp.post('/products/related/delete', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  addRelatedProduct({ rootGetters }, data) {
    return apiShopkeeperApp.post('/products/related/save', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateSelectedTruck({ rootGetters }, data) {
    return apiShopkeeperApp.post('/products/update-truck', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getSelectedTruck({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/products/get-truck/${data.construpUserId}?name=${data.name}&page=${data.page}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  enableOrDisableFreightRule({ rootGetters }, data) {
    return apiShopkeeperApp.post('/freights/active-shipping-rule', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  addFreightRule({ rootGetters }, data) {
    return apiShopkeeperApp.post('/freights/add-rule', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateFreightRule({ rootGetters }, data) {
    return apiShopkeeperApp.post('/freights//update-rule', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteFreightRule({ rootGetters }, data) {
    return apiShopkeeperApp.delete(
      `/freights/delete-rule/${data['id']}/${data['construpUserId']}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getAllShopkeeperFreightRule({ rootGetters }, construpUserId) {
    return apiShopkeeperApp.get(`/freights/get-rule/${construpUserId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAttributeProduct({ rootGetters }, shopkeeperId) {
    return apiShopkeeperApp.get(
      `/products/variations/get-all/${shopkeeperId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  createAttributeProduct({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      '/products/variations/create-attribute',
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  updateAttributeProduct({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      '/products/variations/update-attribute',
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  deleteAttributeProduct({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      '/products/variations/delete-attribute',
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  createValuesAttributeProduct({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      '/products/variations/create-values-attribute',
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  updateValuesAttributeProduct({ rootGetters }, data) {
    return apiShopkeeperApp.post(
      '/products/variations/update-values-attribute',
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  deleteValuesAttributeProduct({ rootGetters }, id) {
    return apiShopkeeperApp.delete(
      `/products/variations/delete-values-attribute/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  addProductAttribute({ rootGetters }, data) {
    return apiShopkeeperApp.post('/products/variations/add-product', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteProductAttribute({ rootGetters }, data) {
    return apiShopkeeperApp.post('/products/variations/delete-product', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteProductAttributeId({ rootGetters }, id) {
    return apiShopkeeperApp.delete(
      `/products/variations/delete-product-attribute/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getVariationSelectedProductsId({ rootGetters }, data) {
    return apiShopkeeperApp.get(
      `/products/variations/get-product-selected/${data.construpUserId}/${data.productId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getDataVariationSelectedProducts({ rootGetters }, construpUserId) {
    return apiShopkeeperApp.get(
      `/products/variations/get-all-product-selected/${construpUserId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },

  // Folhetos
  getTypeFlyers({ rootGetters }, construpUserId) {
    return apiShopkeeperApp.get(`/flyers/show/type/${construpUserId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  createTypeFlyers({ rootGetters }, data) {
    return apiShopkeeperApp.post('/flyers/create/type', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  upateTypeFlyers({ rootGetters }, data) {
    return apiShopkeeperApp.post('/flyers/edit/type', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteTypeFlyers({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/flyers/delete/type/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  createFlyers({ rootGetters }, data) {
    return apiShopkeeperApp.post('/flyers/create', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getDataFlyers({ rootGetters }, data) {
    return apiShopkeeperApp.post('/flyers/edit', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateFlyers({ rootGetters }, data) {
    return apiShopkeeperApp.post('/flyers/edit', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteFlyers({ rootGetters }, id) {
    return apiShopkeeperApp.delete(`/flyers/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  uploadImageFlyer({ rootGetters }, data) {
    return apiShopkeeperApp.post('/flyers/upload', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteImageFlyer({ rootGetters }, data) {
    return apiShopkeeperApp.post('/flyers/delete-image', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
